import {
  Avatar,
  Box,
  ClickAwayListener,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { IconLogout, IconUser } from "@tabler/icons-react";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Text from "../ui/Text";

const ProfileDropdown = () => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { logout, currentUser } = useAuth();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMyProfile = () => {
    navigate("/my-profile");
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      // Handle logout error if needed
    }
    setOpen(false);
  };

  return (
    <>
      {/* Profile Button */}
      <Box
        ref={anchorRef}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          cursor: "pointer",
          borderRadius: "8px",
          p: 1,
          "&:hover": {
            backgroundColor: "#F6F6F6",
          },
        }}
        onClick={handleToggle}
      >
        <Avatar
          src={currentUser?.profile_image_url}
          sx={{
            width: 40,
            height: 40,
            backgroundColor: "#1890FF",
            fontSize: "16px",
            fontWeight: 600,
          }}
        >
          {currentUser?.first_name?.[0]?.toUpperCase()}
          {currentUser?.last_name?.[0]?.toUpperCase()}
        </Avatar>
        <Text variant="subtitle2" sx={{ fontSize: "16px", color: "#000" }}>
          {currentUser?.first_name} {currentUser?.last_name}
        </Text>
      </Box>

      {/* Dropdown Menu */}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-end"
        disablePortal
        sx={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            sx={{
              mt: 1,
              minWidth: 200,
              borderRadius: "8px",
              border: "1px solid #E5E5E5",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Menu Items */}
            <MenuList sx={{ py: 0 }}>
              <MenuItem onClick={handleMyProfile} sx={{ py: 1 }}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <IconUser size={20} />
                </ListItemIcon>
                <ListItemText
                  primary="My Profile"
                  sx={{
                    "& .MuiTypography-root": {
                      fontSize: "16px",
                    },
                  }}
                />
              </MenuItem>

              <Divider sx={{ borderColor: "#fff", margin: "0 !important" }} />

              <MenuItem onClick={handleLogout} sx={{ py: 1 }}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <IconLogout size={20} />
                </ListItemIcon>
                <ListItemText
                  primary="Log out"
                  sx={{
                    "& .MuiTypography-root": {
                      fontSize: "16px",
                    },
                  }}
                />
              </MenuItem>
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default ProfileDropdown;
